import React, { Suspense, useEffect, useState, lazy } from "react";

// Libraries
import { Routes, Route, useLocation } from "react-router-dom";
import retina from "retinajs";
import { AnimatePresence } from "framer-motion";
import { Col, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";

// Context
import GlobalContext from "./Context/Context";

// Components
import ScrollToTopButton from "./Components/ScrollToTop";
import Header, { HeaderNav, Menu } from "./Components/Header/Header";
import SocialIcons from "./Components/SocialIcon/SocialIcons";
import FooterStyle09 from "./Components/Footers/FooterStyle09";
import SkeletonLoader from "./Components/Skeleton/Skeleton";
import { SetHeaderMenuPos, setDocumentFullHeight } from "./Functions/Utilities";

// Home
const MainPage = lazy(() => import("./Pages/Home/Corporate"));
const Page = lazy(() => import("./Pages/Home/Page"));

// Procurement
const RFQPage = lazy(() => import("./Pages/Procurement/RFQPage"));
const TenderPage = lazy(() => import("./Pages/Procurement/TenderPage"));
// Shared Header Data
const SocialIconsData = [
  {
    color: "#828282",
    link: "https://www.linkedin.com/company/oman-tower-company/",
    icon: "fab fa-linkedin",
  },
  {
    color: "#828282",
    link: "https://www.instagram.com/omantower/",
    icon: "fab fa-instagram",
  },
  {
    color: "#828282",
    link: "https://twitter.com/omantower?lang=en",
    icon: "fab fa-twitter",
  },
  {
    color: "#828282",
    link: "https://www.youtube.com/channel/UC5WKC7f3IzF8j4f_6k3mJ_g",
    icon: "fab fa-youtube",
  },
];


function App() {
  const [headerHeight, setHeaderHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNavigating, setIsNavigating] = useState(false);
  const [customModal, setCustomModal] = useState({
    el: null,
    isOpen: false,
  });
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState(location.pathname);

  // RetinaJS
  useEffect(() => {
    window.addEventListener("load", retina(document.querySelectorAll("img")));
  }, []);

  // Disable right-click context menu globally
  useEffect(() => {
    const disableRightClick = (e) => {
      e.preventDefault();
      return false;
    };

    const disableKeyboardShortcuts = (e) => {
      // Disable F12 (Developer Tools)
      if (e.keyCode === 123) {
        e.preventDefault();
        return false;
      }
      // Disable Ctrl+Shift+I (Developer Tools)
      if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
        e.preventDefault();
        return false;
      }
      // Disable Ctrl+Shift+C (Element Inspector)
      if (e.ctrlKey && e.shiftKey && e.keyCode === 67) {
        e.preventDefault();
        return false;
      }
      // Disable Ctrl+Shift+J (Console)
      if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
        e.preventDefault();
        return false;
      }
      // Disable Ctrl+U (View Source)
      if (e.ctrlKey && e.keyCode === 85) {
        e.preventDefault();
        return false;
      }
    };

    // Add event listeners
    document.addEventListener("contextmenu", disableRightClick);
    document.addEventListener("keydown", disableKeyboardShortcuts);

    // Cleanup function to remove event listeners
    return () => {
      document.removeEventListener("contextmenu", disableRightClick);
      document.removeEventListener("keydown", disableKeyboardShortcuts);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      SetHeaderMenuPos();
      setDocumentFullHeight();
    }, 1000);
  }, [location]);

  useEffect(() => {
    if (isModalOpen === true) {
      document.querySelector("body").classList.add("overflow-hidden");
    } else {
      document.querySelector("body").classList.remove("overflow-hidden");
    }
  }, [isModalOpen]);

  // Handle navigation loading based on location changes
  useEffect(() => {
    if (location.pathname !== currentPath) {
      setCurrentPath(location.pathname);
      
      // Reset loading state when route actually changes
      const timer = setTimeout(() => {
        setIsNavigating(false);
      }, 200);
      
      return () => clearTimeout(timer);
    }
  }, [location.pathname, currentPath]);

  // Get the current location and set the window to top
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
    setFooterHeight(0);
    setCustomModal({
      ...customModal,
      el: null,
      isOpen: false,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <GlobalContext.Provider
      value={{
        headerHeight,
        setHeaderHeight,
        footerHeight,
        setFooterHeight,
        isModalOpen,
        setIsModalOpen,
        customModal,
        setCustomModal,
        isNavigating,
        setIsNavigating,
      }}
    >
      <div className="App app-wrapper" style={{ "--header-height": `${headerHeight}px` }}>
        {/* Fixed Header - Always Visible */}
        <header className="fixed-header">
          <Header topSpace={{ md: true }} type="reverse-scroll">
            <HeaderNav 
              fluid="fluid" 
              theme="dark" 
              expand="lg" 
              className="py-[0px] px-[35px] md:px-[15px] md:py-[20px] sm:px-0"
            >
              <Col lg={2} sm={6} xs={"auto"} className="mr-auto ps-0">
                <Link aria-label="header logo" className="flex items-center" to="/">
                  <Navbar.Brand className="inline-block p-0 m-0">
                    <img 
                      className="default-logo" 
                      width="111" 
                      height="36" 
                      loading="lazy" 
                      src='https://admin.omantowerco.om/uploads/logo_Tower_99e1095daa.png' 
                      data-rjs='https://admin.omantowerco.om/uploads/logo_Tower_99e1095daa.png' 
                      alt='logo' 
                    />
                    <img 
                      className="alt-logo" 
                      width="111" 
                      height="36" 
                      loading="lazy" 
                      src='https://admin.omantowerco.om/uploads/log_7ea36d24a8.png' 
                      data-rjs='https://admin.omantowerco.om/uploads/log_7ea36d24a8.png' 
                      alt='logo' 
                    />
                    <img 
                      className="mobile-logo" 
                      width="111" 
                      height="36" 
                      loading="lazy" 
                      src='https://admin.omantowerco.om/uploads/log_7ea36d24a8.png' 
                      data-rjs='https://admin.omantowerco.om/uploads/log_7ea36d24a8.png' 
                      alt='logo' 
                    />
                  </Navbar.Brand>
                </Link>
              </Col>
              <Navbar.Toggle className="order-last md:ml-[17px]">
                <span className="navbar-toggler-line"></span>
                <span className="navbar-toggler-line"></span>
                <span className="navbar-toggler-line"></span>
                <span className="navbar-toggler-line"></span>
              </Navbar.Toggle>
              <Navbar.Collapse className="justify-center col-auto col-lg-8">
                <Menu />
              </Navbar.Collapse>
              <Col lg={2} xs={"auto"} className="justify-end pe-0 flex items-center">
                <SocialIcons
                  theme="social-icon-style-01"
                  size="xs"
                  iconColor="light"
                  data={SocialIconsData}
                />
              </Col>
            </HeaderNav>
          </Header>
        </header>

        {/* Dynamic Content with proper spacing */}
        <main className="main-content">
          <ScrollToTopButton />
          {isNavigating ? (
            <SkeletonLoader />
          ) : (
            <AnimatePresence mode="wait">
              <Suspense fallback={<SkeletonLoader />}>
   <Routes>

  {/* Home */}
  <Route
    path="/"
    element={
      <MainPage style={{ "--base-color": "#2ed47c" }} />
    }
  />

  {/* Procurement - Dynamic RFQ */}
  <Route
    path="/rfq"
    element={
      <RFQPage style={{ "--base-color": "#2ed47c" }} />
    }
  />

  {/* Procurement - Dynamic Tender */}
  <Route
    path="/tender"
    element={
      <TenderPage style={{ "--base-color": "#2ed47c" }} />
    }
  />

  {/* Other Strapi Pages */}
  <Route
    path="/:slug"
    element={
      <Page style={{ "--base-color": "#2ed47c" }} />
    }
  />

</Routes>
              </Suspense>
            </AnimatePresence>
          )}
        </main>

        {/* Fixed Footer */}
        <footer className="fixed-footer">
          <FooterStyle09
            className="bg-pic"
            logo="/assets/img/webp/logo-neon-orange-white.webp"
          />
        </footer>
      </div>
    </GlobalContext.Provider>
  );
}

export default App;
